import CryptoJS from "crypto-js";
import { env } from "../env";

const getEncryptedUser = () =>
    localStorage.getItem("userInfo") || sessionStorage.getItem("userInfo");

export const getStoredUser = () => {
    const encrypted = getEncryptedUser();
    if (!encrypted) return null;
    const secretKey = env.REACT_APP_SECRET_KEY || "";
    try {
        if (!secretKey) return JSON.parse(encrypted);
        const bytes = CryptoJS.AES.decrypt(encrypted, secretKey);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return decrypted ? JSON.parse(decrypted) : null;
    } catch {
        return null;
    }
};

export const getStoredUsername = () => getStoredUser()?.Email || null;
export const getStoredUserId = () => getStoredUser()?.id || null;
export const getStoredCompanyId = () => getStoredUser()?.companyId || 4;
